module.exports = __webpack_public_path__ + "41ce4bf338b332ddc7f301d6febf5799.png";